/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__summary__traffic_avoided_badge = /** @type {(inputs: {}) => string} */ () => {
	return `Vermiedener Verkehr`
};

const en_itinerary__summary__traffic_avoided_badge = /** @type {(inputs: {}) => string} */ () => {
	return `Avoided traffic`
};

const es_itinerary__summary__traffic_avoided_badge = /** @type {(inputs: {}) => string} */ () => {
	return `Tráfico evitado`
};

const fr_itinerary__summary__traffic_avoided_badge = /** @type {(inputs: {}) => string} */ () => {
	return `Trafic évité`
};

const it_itinerary__summary__traffic_avoided_badge = /** @type {(inputs: {}) => string} */ () => {
	return `Traffico evitato`
};

const nl_itinerary__summary__traffic_avoided_badge = /** @type {(inputs: {}) => string} */ () => {
	return `Vermeden verkeer`
};

const pt_itinerary__summary__traffic_avoided_badge = /** @type {(inputs: {}) => string} */ () => {
	return `Tráfego evitado`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__summary__traffic_avoided_badge = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__summary__traffic_avoided_badge(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__summary__traffic_avoided_badge", locale)
	if (locale === "de") return de_itinerary__summary__traffic_avoided_badge(inputs)
	if (locale === "en") return en_itinerary__summary__traffic_avoided_badge(inputs)
	if (locale === "es") return es_itinerary__summary__traffic_avoided_badge(inputs)
	if (locale === "fr") return fr_itinerary__summary__traffic_avoided_badge(inputs)
	if (locale === "it") return it_itinerary__summary__traffic_avoided_badge(inputs)
	if (locale === "nl") return nl_itinerary__summary__traffic_avoided_badge(inputs)
	return pt_itinerary__summary__traffic_avoided_badge(inputs)
};